import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Descriptions from "antd/es/descriptions";
import cn from "classnames";

import styles from "./BaseInfoWindow.module.scss";

interface Props {
  className?: string;
  footer?: React.ReactNode;
  title: string;
  titleIcon?: IconProp;
}

const BaseInfoWindow: React.FC<Props> = ({ children, className, footer, title, titleIcon }) => {
  return (
    <>
      <Descriptions
        bordered
        className={cn(styles.container, className)}
        column={1}
        size="small"
        title={
          <span>
            {titleIcon ? <FontAwesomeIcon className={styles.titleIcon} icon={titleIcon} /> : null}
            {title}
          </span>
        }
      >
        {children}
      </Descriptions>
      {footer && <section className={styles.footer}>{footer}</section>}
    </>
  );
};

export default BaseInfoWindow;
